import React from 'react';
import styled from 'styled-components';
import TextComponent from '../TextComponent';
import { ReactComponent as CheckBoxIconOn } from '@/assets/checkBoxOn.svg';
import { ReactComponent as CheckBoxIconOff } from '@/assets/checkBoxOff.svg';

type BoxWidthType = 'small' | 'normal';
interface Props {
  state: boolean | undefined;
  onClick: any;
  content: string | React.ReactElement;
  type: BoxWidthType;
}

const getWidth = (type: BoxWidthType) => {
  switch (type) {
    case 'small':
      return 24;
    case 'normal':
    default:
      return 32;
  }
};

function CheckBoxComponent(props: Props) {
  const { onClick, content, state, type = 'normal', ...checkBoxProps } = props;
  const width = getWidth(type);

  return (
    <Wrapper onClick={onClick} {...checkBoxProps}>
      {state ? (
        <CheckBoxIconOn width={width} />
      ) : (
        <CheckBoxIconOff width={width} />
      )}
      <CheckBoxText>{content}</CheckBoxText>
    </Wrapper>
  );
}

export default CheckBoxComponent;

const Wrapper = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;
  min-width: 140px;

  &:hover {
    cursor: pointer;
  }
`;

const CheckBoxText = styled(TextComponent)`
  font-size: 20px;
  font-weight: 600;
  margin-left: 8px;
`;
